import React, { useState } from "react";
import "../../../../../styles/ComponentsStyles/Organizational/Management/Staffs/PageHeaderCustomComponent.style.css";
import SearchIcon from "../../../../../assets/Icons/Pages/Organizational/Management/Members/Search.svg";
import FilterIcon from "../../../../../assets/Icons/Pages/Organizational/Management/Staffs/FilterIcon.svg";

const PageHeaderCustomComponent = () => {
  const [showFilter, setShowFilter] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState([]);

  const handleFilterChange = (value) => {
    setSelectedFilters((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };

  return (
    <div className="flex-col g-05 align-start justify-end">
      <div className="staffsPageHeaderCustomComponent">
        <div className="searchInputContainer">
          <input
            type="text"
            className="pageHeaderInput"
            placeholder="Type for search"
          />
          <button className="searchBtn">
            <img src={SearchIcon} alt="Search" />
          </button>
        </div>
        <div className="staffsFilterSearchButtonContainer">
          <button onClick={() => setShowFilter(!showFilter)}>
            <img src={FilterIcon} alt="Filter icon" />
            <span className="filterText">Filter</span>
          </button>
          {showFilter && (
            <ul className="filterDropdown">
              {["Security", "Manager", "Super"].map((role) => (
                <li key={role}>
                  <input
                    type="checkbox"
                    value={role}
                    checked={selectedFilters.includes(role)}
                    onChange={() => handleFilterChange(role)}
                  />
                  <span>{role}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageHeaderCustomComponent;
